import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyArNyNYbbwG-v_yl0moOkQ5Tk7MV6Q1iT4",
  authDomain: "finance-33d8e.firebaseapp.com",
  projectId: "finance-33d8e",
  storageBucket: "finance-33d8e.firebasestorage.app",
  messagingSenderId: "107756195999",
  appId: "1:107756195999:web:b0144a2b669779b9e7d2aa"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
